import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import 'common/css/master.css';
import DatePicker from "react-datepicker";
import Header from 'common/js/header/header.js';
import Duty from './duty'
import { viewReportSvc,getLstRoles, getLstPeriod2, getLstAbsentTch2, getLstSubs2, getLstTch2, getHeaderDates2, setMarkAbsent2, assignSubsTchDuty2, removeSubsTchDuty2, informAll, autoSubstitutionSvc2, removeAllSubstitutionSvc2 } from './disruptionServices'
import SubsTchTbl from './subsTchTbl';
import TchSlider from './tchSlider';
import HeaderDtTab from './headerDtTab';
import ViewSlider from './viewSlider';
import AbsentPopup from './absentPopup';
import { dtToDMY, dmyToDate } from 'common/functions/dateUtil';
const DisruptionCtrl = () => {
    var initialState = {
        loader: 'none',
        opacity: 1,
        fromDt: null,
        toDt: null
    };
    const [sliderDisplayed, setSliderDisplayed] = useState(false)
    const [selDt, setSelDt] = useState('')
    const [selClsId, setSelClsId] = useState(0)
    const [selSecId, setSelSecId] = useState(0)
    const [selRoleId, setSelRoleId] = useState(0)
    const [selPeriodId, setSelPeriodId] = useState(0)
    const [selSubId, setSelSubId] = useState(0)
    const [selSubsTchId, setSelSubsTchId] = useState(0)
    const [selTchId, setSelTchId] = useState(0)
    const [lstPeriod, setLstPeriod] = useState([])
    const [lstAbsentTch, setLstAbsentTch] = useState([])
    const [lstSubsTch, setLstSubsTch] = useState([])
    const [lstTch, setLstTch] = useState([])
    const [completionPct, setCompletionPct] = useState({})
    const [state, setState] = useState(initialState);
    const [cellDtls, setCellDtls] = useState({});
    const [datesObj, setDatesObj] = useState({});
    const [lstRole, setlstRole] = useState([]);
    const [absentTchId, setAbsentTchId] = useState(0);
    const [selAbsentTchId, setSelAbsentTchId] = useState(0);
    const [flgAbsent, setFlgAbsent] = useState(false);
    const [flg, setFlg] = useState(false);
    const [needSyllabusCoverage, setNeedSyllabusCoverage] = useState(true);
    const [flgAbsentPopupVisible, setFlgAbsentPopupVisible] = useState(false);


    useEffect(() => {
        setRoles();
        next(new Date());
    }, []);


    function next(dt) {
        dt = getDtDDMMYYYY(dt);
        showLoader();
        getHeaderDates2(dt, handleDtResponse);
    }

    function getDtDDMMYYYY(dt) {
        if (dt === "" || dt === null)
            return;
        var dd = dt.getDate();
        var mm = dt.getMonth() + 1;

        var yyyy = dt.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        return (dd + '-' + mm + '-' + yyyy);
    }

    function prev() {
        var startDate = new Date();
        startDate.setDate(startDate.getDate() - 7);
        next(startDate)
    }

    const rowClickInMain = (e) => {
        var tchId = JSON.parse(e.currentTarget.getAttribute("tch-id"));
        setSelTchId(tchId)
        // console.log("selSubsId=" + selSubsId + "tchId=" + tchId + ",selClsId=" + selClsId + ",selSecId=" + selSecId + ",selPeriodId=" + selPeriodId + ",selDt=" + selDt + ",absentTchId=" + absentTchId + ",selSubId=" + selSubId);
        setSubs(selDt, cellDtls.clsId, cellDtls.sectionId, cellDtls.periodId, cellDtls.subId, tchId);
        // console.log("selSubsTchId:"+selSubsTchId+", tchId:"+tchId+", selClsId:"+selClsId+", selSecId:"+selSecId+", selPeriodId:"+selPeriodId+", selDt:"+selDt+", absentTchId:"+absentTchId+", selSubId:"+selSubId)
        assignTchDuty(
            selSubsTchId
            , tchId
            , selClsId
            , selSecId
            , selPeriodId
            , selDt
            , absentTchId
            , selSubId)

    }

    function setRoles() {
        showLoader();
        getLstRoles(handlelstRoleResponse);
    }
    function showLoader() {
        setState({ ...state, loader: 'block', opacity: 0.5 });
    }
    function hideLoader() {
        setState({ ...state, loader: 'none', opacity: 1 });
    }
    function setPeriods(dt) {
        showLoader();
        getLstPeriod2(dt, handlePeriodResponse);
    }

    function setAbsentTchs(dt) {
        showLoader();
        getLstAbsentTch2(dt, handleAbsentTchResponse);
    }

    function setSubs(dt, pClsId, pSEcId, pPeriodId, pSubId, pTchId) {
        showLoader();
        // console.log("setSubs called with dt: " + dt);
        // console.log("selRoleId: ", selRoleId);
        // console.log("clsId", pClsId);
        // console.log("secId", pSEcId);
        // console.log("periodId", pPeriodId);
        // console.log("subId", pSubId);
        // console.log("tchId", pTchId);

        getLstSubs2(dt, selRoleId, pClsId, pSEcId, pPeriodId, pSubId, pTchId, handleSubsResponse);
    }

    function setTchs(dt) {
        showLoader();
        getLstTch2(dt, handleTchsResponse);
    }

    const openAbsentPopup = async (tchId, absent) => {
        await setSelAbsentTchId(tchId);
        await setFlgAbsent(absent);
        setFlgAbsentPopupVisible(true);
    }

    function markAbsent(stTm, endTm) {
        showLoader();
        // console.log("selDt:" + selDt)
        setMarkAbsent2(stTm, endTm, selDt, selAbsentTchId, flgAbsent, needSyllabusCoverage, handleMarkAbsentResponse)
        setFlgAbsentPopupVisible(false);
    }


    function assignTchDuty(subsId, subsTchId, clsId, sectionId, periodId, dt, subjectId) {
        var obj = {
            subsId: !subsId ? 0 : subsId,
            subsTchId: !subsTchId ? 0 : subsTchId,
            clsId: clsId,
            sectionId: sectionId,
            periodId: periodId,
            dt: dt,
            subjectId: selSubId,
            absentTchId: absentTchId,


        };
        // console.log('obj=' + JSON.stringify(obj))
        showLoader();
        assignSubsTchDuty2(obj, handleAssignDutyResponse);
    }

    function removeTchDuty(e, subsId, subsTchId, periodId, clsId, sectionId, remarks) {
        e.stopPropagation();
        e.preventDefault();
        showLoader();
        setSubs(selDt, cellDtls.clsId, cellDtls.sectionId, cellDtls.periodId, cellDtls.subId, subsTchId);
        removeSubsTchDuty2(selDt, subsId, subsTchId, periodId, clsId, sectionId, remarks, handleRemoveDutyResponse);
    }

    function handlelstRoleResponse(data) {
        var obj = data;
        hideLoader();
        if (obj.status === 'Success') {
            setlstRole(obj.lstRole);
        } else if (obj.status === 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false
            } else {
                toast.error(obj.message)
            }
        } else {
            toast.error('Service failed' + obj);
        }
    }
    function handlePeriodResponse(data) {
        hideLoader();
        var obj = data;
        if (obj.status === 'Success') {
            setLstPeriod(obj.lstPeriod);
        } else if (obj.status === 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        } else {
            toast.error("Service failed " + obj);
        }
    }

    function handleAbsentTchResponse(data) {
        hideLoader();
        var obj = data;
        if (obj.status === 'Success') {
            setLstAbsentTch(obj.lstAbsentTch);
            setCompletionPct(obj.completionPct);
        } else if (obj.status === 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        } else {
            toast.error("Service failed " + obj);
        }
    }

    function handleSubsResponse(data) {
        hideLoader();
        var obj = data;
        if (obj.status === 'Success') {
            setLstSubsTch(obj.lstSubsTch);
        } else if (obj.status === 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        } else {
            toast.error("Service failed " + obj);
        }
    }

    function handleTchsResponse(data) {
        hideLoader();
        var obj = data;
        if (obj.status === 'Success') {
            setLstTch(obj.lstTch);
        } else if (obj.status === 'Failure') {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (obj.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        } else {
            toast.error("Service failed " + obj);
        }
    }

    function handleMarkAbsentResponse(data) {
        hideLoader();
        if (data.status === 'Success') {
            toast.success(data.message);
            setTchs(selDt);
            setAbsentTchs(selDt);
            setNeedSyllabusCoverage(data.needSyllabusCoverage)
        } else if (data.status === 'Failure') {
            if (data.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (data.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(data.message)
            }
        } else {
            toast.error("Service failed " + data.message);
        }
    }

    function handleAssignDutyResponse(data) {
        hideLoader();
        if (data.status === 'Success') {
            toast.success(data.message);
            setAbsentTchs(selDt);
        } else if (data.status === 'Failure') {
            if (data.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (data.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else {
                toast.error(data.message);
            }
        } else {
            toast.error("Service failed " + data.error);
        }
    }
    function handleRemoveDutyResponse(data) {
        hideLoader();
        if (data.status === 'Success') {
            toast.success(data.message);
            setAbsentTchs(selDt);
        } else if (data.status === 'Failure') {
            if (data.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (data.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(data.message)
            }
        } else {
            toast.error("Service failed " + data.error);
        }
    }

    function handleDtResponse(data) {
        hideLoader();
        var obj = data;
        if (obj.status === 'Success') {
            setDatesObj(obj.lstDates);
        } else {
            if (obj.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(data.message);
            }
        }
    }


    function handleEditClick(e, val) {
        e.preventDefault();
        if (val)
            showSlider();
        else
            closeSlider();
    }

    const handleRemoveSubstituion = () => {
        // give a warning it will remove all the substitution for the selected date
        if (!window.confirm("Are you sure you want to remove all substitutions for " + selDt + "?")) {
            return;
        } else {
            // console.log("handleRemoveSubstituion called, selDt: ", selDt);
            showLoader();
            removeAllSubstitutionSvc2(selDt, handleRemoveDutyResponse);
        }
    }

    const showSlider = () => {
        setSliderDisplayed(true);
    };

    const closeSlider = () => {
        setSliderDisplayed(false);
    };

    function onInformAllClick() {
        // console.log("onInformAllClick called");
        informAll(selDt, handleInformAllResponse);
    }

    function autoSubstitution() {
        // console.log("autoSubstitution called");
        autoSubstitutionSvc2(selDt, handleInformAllResponse);
    }

    function handleInformAllResponse(data) {
        hideLoader();
        if (data.status === 'Success') {
            toast.success(data.message);
            onDtTabClicked(selDt);
        } else if (data.status === 'Failure') {
            if (data.message === 'You are not logged in') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            }
            else if (data.message === 'Your Session is expired, login again') {
                setTimeout(function () { window.location.href = ('/') }, 2000);
                return false;
            } else {
                toast.error(data.message);
            }
        } else {
            toast.error("Service failed " + data.error);
        }
    }
    const onSelectDate = (dt) => {
        next(dt);
        onDtTabClicked(dtToDMY(dt));
    }

    async function onDtTabClicked(dt) {
        // console.log("onDtTabClicked called, dt", dt);
        await setLstPeriod([]);
        await setLstAbsentTch([]);
        // await setCompletionPct({
        //     "completed": 0,
        //     "total": 0,
        //     "pct": 0
        // });
        await setLstTch([]);
        setSelDt(dt)
        setPeriods(dt);
        setAbsentTchs(dt);
        setTchs(dt);

    }
    async function onCellClicked(cell, periodId, absentTchId, clsId, sectionId, subId, subsTchId) {
        // console.log("onCellClicked called, cell: ", cell );
        // console.log("onCellClicked called, cell: ", JSON.stringify(cell, null, 2));
        // console.log("absentTchId= " + absentTchId);
        // console.log("clsId= " + clsId);
        // console.log("sectionId= " + sectionId);
        // console.log("subId= " + subId);
        // console.log("subsId= " + subsId);


        await setSelClsId(clsId)
        await setSelSubId(subId)
        await setSelSecId(sectionId)
        await setCellDtls(cell);
        await setSelSubsTchId(subsTchId);
        await setAbsentTchId(absentTchId);
        setSubs(selDt, clsId, sectionId, periodId, subId, absentTchId);

    }
    function setFlgView(params) {
        setFlg(params)
    }
    function setFlgClose() {
        setFlg(false)
    }
    const getWingId = (wingId) => {
        // console.log("wingId" + wingId);
    }
    function downloadExcel() {
        console.log(selDt)
        showLoader()
        getData(selDt, selDt);
    }
    function getData(from, to) {
        viewReportSvc(from, to, cbViewReportResponse);
    }
    function cbViewReportResponse(data) {
        hideLoader();
        var url = document.createElement("a");
        url.href = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/octet-stream" })
        );
        url.download = "DailySubsDuty.xlsx";
        document.body.appendChild(url);
        url.click();
        setTimeout(function () {
            window.URL.revokeObjectURL(url);
        }, 200);
    }


    const toDMY = (dt) => {
        var tmpDd = dt.getDate();
        var dd = tmpDd < 9 ? "0" + tmpDd : tmpDd;
        var mon = dt.getMonth() + 1;
        var mm = mon < 10 ? "0" + mon : mon;
        let dmyDate = dd + "-" + mm + "-" + dt.getFullYear();
        return dmyDate;
    }

    return (
        <div style={{ height: '100%' }}>
            <Header wingFromChild={getWingId} />
            <ToastContainer autoClose={3000} hideProgressBar />
            <div style={{ position: 'fixed', zIndex: 10000, width: 100, height: 100, marginLeft: -50, marginTop: -50, left: '50%', top: '50%', display: state.loader }}>
                <img className="loderImg" src={require("common/images/loader.gif")} alt="Loader..." />
            </div>
            <div className="mainContainer" style={{ marginTop: 15, opacity: state.opacity }}>
                <div className="col-md-12 col-centered wingsWrap clearfix">
                    <div className='col-lg-5 col-sm-6 col-xs-8 padding-remove' style={{ height: 50 }}>
                        {datesObj &&
                            <HeaderDtTab
                                lstDates={datesObj}
                                next={next}
                                prev={prev}
                                onDtTabClicked={onDtTabClicked}
                                selDt={selDt} />
                        }
                    </div>
                    <div className='col-sm-2 padding-remove' style={{ height: 50 }}>

                        <div className="col-sm-8 padding-remove position-relative">
                            <DatePicker
                                id="selDt"
                                className="form-control pr-4" // Add padding-right to prevent text overlap with icon
                                placeholderText="Select Date"
                                selected={dmyToDate(selDt)}
                                onChange={(dt) => onSelectDate(dt)}
                                dateFormat="dd-MM-yyyy"
                                dropdownMode="select"
                                autoComplete="off"
                                showMonthDropdown
                                showYearDropdown
                                adjustDateOnChange
                            />
                            <span
                                id="calendar"
                                title="calendar"
                                className="glyphicon glyphicon-calendar"
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666",
                                }}
                                onClick={() => document.getElementById("selDt").focus()} // Open DatePicker when clicked
                            ></span>
                        </div>

                    </div>
                    <div className="col-sm-12 padding-remove" style={{ marginTop: '1%' }}>
                        <div className="col-sm-7 padding-remove"
                            style={{ width: '58%', height: '80vh' }}>
                            {
                                <Duty
                                    lstPeriod={lstPeriod}
                                    selTchId={selTchId}
                                    selPeriodId={selPeriodId}
                                    setSelPeriodId={setSelPeriodId}
                                    setSelTchId={setSelTchId}
                                    setCellDtls={setCellDtls}
                                    lstAbsentTch={lstAbsentTch}
                                    completionPct={completionPct}
                                    onCellClicked={onCellClicked}
                                    removeTchDuty={removeTchDuty}
                                    informAll={onInformAllClick}
                                    downloadExcel={downloadExcel}
                                    autoSubstitution={autoSubstitution}
                                    setFlgView={setFlgView}
                                    handleRemoveSubstituion={handleRemoveSubstituion}
                                />}
                        </div>
                        <div className='slider halfWidthSlider' style={{ right: 0, opacity: 1, display: flg === true ? 'block' : 'none', zIndex: 10000 }}>
                            <ViewSlider
                                selDt={selDt}
                                setFlgClose={setFlgClose}
                                flg={flg}
                            ></ViewSlider>
                        </div>
                        <div style={{ marginTop: '4.5%' }}>
                            <div className="col-sm-1 padding-remove" style={{ width: '3%', textAlign: 'center' }}>
								 {/* <span className="glyphicon glyphicon-download" style={{ cursor: 'pointer' }} onClick={(e) => downloadExcel()}></span>*/}

                                {/* <div>
                                    <span className="glyphicon glyphicon-remove cross-icon" style={{ cursor: 'pointer' }} onClick={(e) => handleRemoveSubstituion(e)}></span>
                                </div> */}
                                <div>
                                    <span className="glyphicon glyphicon-edit" style={{ cursor: 'pointer' }} onClick={(e) => handleEditClick(e, true)}></span>
                                </div>
                            </div>
                            <div className="col-sm-4 padding-remove" style={{ width: '39%', height: '80vh' }}>
                                {lstSubsTch && <SubsTchTbl
                                    lstSubsTch={lstSubsTch}
                                    rowClick={rowClickInMain}
                                    selTchId={selTchId}
                                />}
                            </div>
                        </div>
                    </div>
                    {sliderDisplayed && <Slider lstTch={lstTch} cboxClick={openAbsentPopup} />}
                </div>
            </div>
            {
                flgAbsentPopupVisible ?
                    <AbsentPopup
                        markFullDayAbsent={markAbsent}
                        tchId={selAbsentTchId}
                        onClose={() => setFlgAbsentPopupVisible(false)}
                    />
                    : null
            }
        </div>
    )

    function Slider(props) {
        return (
            <div className="slider halfWidthSlider" style={{ opacity: sliderDisplayed ? 1 : 0, right: 0 }}>
                <TchSlider lstTch={props.lstTch} cboxClick={props.cboxClick} lstRole={lstRole} needSyllabusCoverage={needSyllabusCoverage} setNeedSyllabusCoverage={setNeedSyllabusCoverage} />
                <button type="button" className="btn btn-info text-center " id="closeSlider" style={{ opacity: sliderDisplayed ? 1 : 0, right: '70%' }} onClick={(e) => handleEditClick(e, false)}>
                    <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
                </button>
            </div>
        )
    }



}
export default DisruptionCtrl;